import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import Helmet from 'react-helmet';
import headersList from 'Constants/headersList';
import Drawer from "@material-ui/core/Drawer";
import clipListEmpty from "../../../Assets/Images/clip-list-is-empty.png";
import windowsIcon from "../../../Assets/Images/microsoft-windows.png";


export default class AddDevice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };

        this.openDeviceGroup = this.openDeviceGroup.bind(this);
        this.closeDrawer = this.closeDrawer.bind(this);
    }

    openDeviceGroup() {
        this.setState({
          open: true,
        });
    }

    closeDrawer() {
        this.setState({
          open: false,
          menu: null,
        });
    }

    render() {
        return (
            <div className="content-outer-wrapper-with-tab">
                        <Helmet>
                        <title>{ headersList.Attendance.Biometric.header }</title>
        </Helmet>
                {/* <div className="innerwrapperheader2">
                    <div className="innerwrapper-page-header">Biometric Dashboard</div>
                </div> */}
                <div>
                    <div style={{ display: "table", height: "75vh", width: "100%" }}>
                        <div className="display-table-cell vertical-middle">
                            <Grid container>
                                <Grid item xs={12} md={12} sm={12}>
                                    <div>
                                        <img className="clipListEmpty" src={clipListEmpty} />
                                        <div className="t-20" style={{
 lineHeight: "24px", textAlign: "center", fontWeight: "bold", color: "#000",
}}>You have not added any Biometric Device to sumHR yet</div>
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} sm={12}>
                                    <Grid container className="biometric-steps-container padding-bottom-0">

                                        <Grid item xs={12} md={4} sm={12} className="biometric-steps-container">
                                            <div>
                                                <span className="biometric-step">1</span>
                                            </div>
                                            <div className="text-center">
                                                <i className="material-icons add-device-icon">cloud_download</i>
                                            </div>
                                            <div className="t-18" style={{ lineHeight: "22px", textAlign: "center", color: "#000" }}>
                                                <span>
                                                    Download, Install <br></br> and Run setup
                                                </span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} md={4} sm={12} className="biometric-steps-container">
                                            <div>
                                                <span className="biometric-step">2</span>
                                            </div>
                                            <div className="text-center">
                                                <i className="material-icons add-device-icon">add</i>
                                            </div>
                                            <div className="t-18" style={{ lineHeight: "22px", textAlign: "center", color: "#000" }}>
                                                <span>
                                                    Add Device
                                                </span>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} md={4} sm={12} className="biometric-steps-container">
                                            <div>
                                                <span className="biometric-step">3</span>
                                            </div>
                                            <div className="text-center">
                                                <i className="material-icons add-device-icon">person_add</i>
                                            </div>
                                            <div className="t-18" style={{ lineHeight: "22px", textAlign: "center", color: "#000" }}>
                                                <span className="display-block">
                                                    Register Employee <br></br> on Device
                                                </span>
                                                <span style={{ fontSize: 14, lineHeight: "18px" }}>
                                                    *Note down Employee ID <br></br> while registering
                                                </span>
                                            </div>
                                        </Grid>

                                    </Grid>

                                </Grid>
                                <Grid item xs={12} md={12} sm={12}>
                                    {/* <Button className="get-started-btn" color="primary" variant="contained" onClick={()=>this.props.createDevice(false)}>GET STARTED</Button> */}
                                    <Button className="get-started-btn" color="primary" variant="contained" onClick={this.openDeviceGroup}>GET STARTED</Button>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>

            <Drawer
            anchor="right"
            open={this.state.open}
            onClose={this.closeDrawer}
            classes={{
              paper: "bio-drawer",
            }}
          >
            <div>
                <div className="formwrapper">
                    <span className="drawer-cancle-btn">
                        <svg onClick={this.closeDrawer} width="24" height="24" viewBox="0 0 24 24">
                        <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                        </svg>
                    </span>
                    <p className='title'>Getting Started</p>
                    <div>
                        <p className="t-14">Please download our biometric/RFID (eSSL Device)
                            app installation file from here. Contact our support
                            team (support@sumhr.com) for help regarding the
                            setup and installation of this application.
                        </p>
                    </div>
                    <div className="margin-top-20">
                    <p className="form-main-header">1. eSSL</p>
                    <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                            <div className="download-app">
                                <img className="windows-icon" src={windowsIcon} />
                                <p style={{
 color: "#fff", paddingTop: 5, fontSize: 14, float: "left",
}}>Download <br></br>Windows App</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <div className="padding-top-10">
                                <i className="material-icons floatleft margin-right-8" style={{ color: "#0072ff", fontSize: 22 }}>cloud_download</i>
                                <p style={{ color: "#0072ff" }}>Instruction Manual</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                    <div className="margin-top-20">
                    <p className="form-main-header">2. eSSL (Black and White)</p>
                    <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                            <div className="download-app">
                                <img className="windows-icon" src={windowsIcon} />
                                <p style={{
 color: "#fff", paddingTop: 5, fontSize: 14, float: "left",
}}>Download <br></br>Windows App</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <div className="padding-top-10">
                                <i className="material-icons floatleft margin-right-8" style={{ color: "#0072ff", fontSize: 22 }}>cloud_download</i>
                                <p style={{ color: "#0072ff" }}>Instruction Manual</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                    <div className="margin-top-20">
                    <p className="form-main-header">3. SmackBio</p>
                    <Grid container>
                        <Grid item xs={12} md={6} sm={12}>
                            <div className="download-app">
                                <img className="windows-icon" src={windowsIcon} />
                                <p style={{
 color: "#fff", paddingTop: 5, fontSize: 14, float: "left",
}}>Download <br></br>Windows App</p>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6} sm={12}>
                            <div className="padding-top-10">
                                <i className="material-icons floatleft margin-right-8" style={{ color: "#0072ff", fontSize: 22 }}>cloud_download</i>
                                <p style={{ color: "#0072ff" }}>Instruction Manual</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                    <div style={{ position: "fixed", bottom: 10 }}>
                        <p className="t-14">Can’t find your device listed above?</p>
                        <p className="t-14">Mail us at <span style={{ color: "#027dff" }}>support@sumhr.com</span></p>
                    </div>
                </div>
            </div>

          </Drawer>

            </div>
        );
    }
}
